import styled from 'styled-components';

import { Button, fontWeight, FontWeights, minWidth } from '@calm-web/design-system';

import GridWrapper from '@/components/ui/GridWrapper';

export const Wrapper = styled.div`
	margin-bottom: 100px;
	text-align: center;
`;

export const Heading = styled.h2`
	${fontWeight(FontWeights.Light)};
	margin-bottom: 36px;
`;

export const Tiles = styled(GridWrapper)`
	grid-row-gap: 54px;
	grid-template-columns: 1fr;
	margin-bottom: 90px;

	${minWidth('tablet')} {
		grid-template-columns: 1fr 1fr;
	}
`;

export const Tile = styled.div`
	border-radius: 16px;
	box-shadow: rgba(0, 0, 0, 0.08) 0px 8px 24px 0px;
	height: 350px;
	overflow: hidden;
	position: relative;
`;

export const TileContent = styled.p`
	align-items: center;
	background: rgba(255, 255, 255, 0.9);
	bottom: 0px;
	box-sizing: border-box;
	color: rgb(56, 56, 56);
	display: flex;
	${fontWeight(FontWeights.Medium)};
	height: 88px;
	justify-content: center;
	padding: 0px 0.75rem;
	position: absolute;
	text-align: center;
	width: 100%;
`;

export const FeaturesButton = styled(Button)`
	max-width: 250px;
	width: 100%;
`;
